import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { injectIntl } from 'react-intl'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Button from '@material-ui/core/Button'
import messages from 'components/Apps/SlaMonitor/translate'
import { setEnvironmentType } from 'reducers/slaMonitor/environment/reducer'
import { TYPE_WEATHER, TYPE_SENSOR } from 'helpers/environmentMonitor'

class DataTypeSwitch extends Component {
  onBtnModuleClick = e => {
    this.props.setEnvironmentType({
      type: e.currentTarget.dataset.type,
    })
  }

  render() {
    const {
      type,
      intl: { formatMessage },
    } = this.props

    return (
      <ButtonGroup className="button-group type-switch">
        <Button
          className={cn({
            active: type === TYPE_WEATHER,
          })}
          data-type={TYPE_WEATHER}
          onClick={this.onBtnModuleClick}>
          {formatMessage(messages.weather)}
        </Button>
        <Button
          className={cn({
            active: type === TYPE_SENSOR,
          })}
          data-type={TYPE_SENSOR}
          onClick={this.onBtnModuleClick}>
          {formatMessage(messages.sensor)}
        </Button>
      </ButtonGroup>
    )
  }
}

export default connect(
  state => ({
    type: state.getIn(['environment', 'type']),
  }),
  {
    setEnvironmentType,
  },
)(injectIntl(DataTypeSwitch))
